import { warn } from '@execonline-inc/logging';
import { fromNullable } from 'maybeasy';
import * as React from 'react';
import { handleEnterKeyPress, handleEscKeyDown } from '../../../../../Accessibility/KeyboardEvents';
import clickOutsideStore from '../../../../../ClickOutsideStore';
import VerticalMenuIcon from '../../../../Cutesies/VerticalMenuIcon';
import { useOpenable } from '../../../../Modal/UseOpenable';
import ModalBody from './ModalBody';

interface Props {
  content: React.ReactNode;
}

function ActionMenu({ content }: Props) {
  const actionItemsRef = React.useRef<HTMLDivElement | null>(null);
  const { modalState, open, close } = useOpenable();

  const openWithListener = () => {
    fromNullable(actionItemsRef)
      .do(() => clickOutsideStore.addListener({ ref: actionItemsRef, callback: close }))
      .elseDo(() => warn(`Element not found. Modal may not work`));
    open();
  };

  switch (modalState.kind) {
    case 'open':
      return (
        <div
          onClick={close}
          ref={actionItemsRef}
          data-test-actionitems={true}
          data-intercom-target="participants-bulk-action-menu"
          id="popover-container"
          tabIndex={-1}
          className="relative flex rounded-md border border-solid border-teal-600 h-full w-12 justify-center"
        >
          <div
            tabIndex={0}
            onKeyPress={handleEnterKeyPress(close)}
            onKeyDown={handleEscKeyDown(close)}
            className="cursor-pointer relative flex items-center"
          >
            <VerticalMenuIcon fill={'#187A90'} />
          </div>
          <ModalBody close={close} body={content} />
        </div>
      );
    case 'closed':
      return (
        <div
          onClick={openWithListener}
          ref={actionItemsRef}
          data-test-actionitems={true}
          data-intercom-target="participants-bulk-action-menu"
          id="popover-container"
          tabIndex={-1}
          className="relative rounded-md border border-solid border-teal-600 h-full w-12 flex justify-center"
        >
          <div
            tabIndex={0}
            onKeyPress={handleEnterKeyPress(openWithListener)}
            onKeyDown={handleEscKeyDown(close)}
            className="cursor-pointer relative flex items-center"
          >
            <VerticalMenuIcon fill={'#187A90'} />
          </div>
        </div>
      );
  }
}

export default ActionMenu;
